module.exports = __webpack_public_path__ + "static/img/12.5bb946e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/customerCase/12.png
// module id = +6vW
// module chunks = 0